import { put, fork, call, select, takeEvery, takeLatest, all } from 'redux-saga/effects';
import app from '../../app';
import {
  loadInviteeListCompletion,
  loadAwardListCompletion,
  getSharePostCompletion,
  loadMemberMineBannerListCompletion,
} from '../../actions';
import { formatterMonth } from '../../utils/formatters';

export function* watchLoadInviteeList() {
  yield takeEvery('LOAD_INVITEE_LIST', function*() {
    const options = {
      url: `/api/user/inviteOrder/record`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadInviteeListCompletion(result.data, result.error));
  });
}

export function* watchLoadAwardList() {
  yield takeLatest('LOAD_AWARD_LIST', function*({ willReload }) {
    const { list, query } = yield select(
      state => state.member.mine.awardMaster
    );
    const tabDict = { all: '', wait: 1, success: 2, fail: -1 };
    let start = 0;
    let tab = 0;

    if (!willReload && list) {
      start = list.length;
    }
    tab = tabDict[query.tab];

    const timeScope = formatterMonth(query.timeScope);
    const options = {
      url: `/api/b/wallet/reward/records?start=${start}&size=${query.size}&status=${tab}&startTime=${timeScope.startTime}&endTime=${timeScope.endTime}`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(
      loadAwardListCompletion(
        result.error,
        (result.data && result.data.listData) || []
      )
    );
  });
}

export function* watchGetSharePost() {
  yield takeEvery('GET_SHARE_POST', function*() {
    const options = {
      url: `/api/user/share/poster`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(getSharePostCompletion(result.error, result.data));
  });
}

export function* watchLoadMemberMineBannerList() {
  yield takeEvery('LOAD_MEMBER_MINE_BANNER_LIST', function*() {
    const options = {
      url: '/api/index/banner',
      data: {
        client: 0,
        topic: 4,
      },
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadMemberMineBannerListCompletion(result.error, result.data));
  });
}

export default function* mineSaga() {
  yield all([
    fork(watchLoadInviteeList),
    fork(watchLoadAwardList),
    fork(watchGetSharePost),
    fork(watchLoadMemberMineBannerList),
  ]);
}
